import React from 'react';
import './customer.css';

const customerPromises = [
  {
    number: '01',
    label: 'You are understood',
    title: 'Your goals come before the technology.',
    description:
      'We take time to understand your business, customers and challenges before recommending a direction.',
    tags: ['Careful discovery', 'Honest advice', 'Clear priorities'],
  },
  {
    number: '02',
    label: 'You stay involved',
    title: 'No black box. No unexpected surprises.',
    description:
      'You see the progress, understand the decisions and have a clear voice throughout the project.',
    tags: ['Direct contact', 'Visible progress', 'Shared decisions'],
  },
  {
    number: '03',
    label: 'You are supported',
    title: 'The relationship continues after launch.',
    description:
      'We remain available for improvements, maintenance and the next stage of your digital growth.',
    tags: ['Reliable launch', 'Ongoing support', 'Long-term thinking'],
  },
];

const expectations = [
  'A dedicated point of contact',
  'Straightforward communication',
  'Respect for your time and budget',
  'Solutions made for real use',
  'Clear ownership and responsibility',
  'Support beyond delivery',
];

const Customer = () => {
  return (
    <section className="customer-container" id="customer">
      <div className="customer-glow customer-glow-one" aria-hidden="true" />
      <div className="customer-glow customer-glow-two" aria-hidden="true" />

      <div className="customer-inner">
        <header className="customer-heading">
          <div>
            <span className="customer-eyebrow">OUR CUSTOMERS</span>
            <h2>Your success stays at the centre of every decision.</h2>
          </div>
          <div className="customer-heading-copy">
            <p>
              Great digital work is built through trust. That means listening
              carefully, communicating clearly and taking responsibility for the
              result—not simply delivering files and moving on.
            </p>
            <a href="#contact">
              Become a Kodex customer <span aria-hidden="true">→</span>
            </a>
          </div>
        </header>

        <div className="customer-types">
          {customerPromises.map((promise) => (
            <article className="customer-type-card" key={promise.number}>
              <div className="customer-type-top">
                <span className="customer-type-number">{promise.number}</span>
                <span className="customer-type-line" aria-hidden="true" />
                <span className="customer-type-label">{promise.label}</span>
              </div>
              <h3>{promise.title}</h3>
              <p>{promise.description}</p>
              <div className="customer-type-tags">
                {promise.tags.map((tag) => <span key={tag}>{tag}</span>)}
              </div>
            </article>
          ))}
        </div>

        <div className="customer-focus">
          <div className="customer-focus-visual" aria-hidden="true">
            <span className="customer-orbit customer-orbit-one" />
            <span className="customer-orbit customer-orbit-two" />
            <span className="customer-orbit customer-orbit-three" />
            <div className="customer-focus-core">
              <small>FOCUSED ON</small>
              <strong>Your success</strong>
            </div>
          </div>

          <div className="customer-focus-content">
            <span className="customer-focus-kicker">A BETTER CUSTOMER EXPERIENCE</span>
            <h3>A partnership built on trust, not transactions.</h3>
            <p>
              Our customers should always feel informed, respected and confident
              about what comes next. These are not optional extras—they are the
              foundation of how we work together.
            </p>
            <div className="customer-industries">
              {expectations.map((expectation) => <span key={expectation}>{expectation}</span>)}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Customer;
